import { PieChart } from 'bricks-ui/packages/bricks-ui';
export default PieChart;
